import Orders from 'components/pages/Orders';
import PurchaseOrders from 'components/pages/PurchaseOrders';
import OrderTracking from 'components/pages/OrderTracking';
import OrderIcon from '@material-ui/icons/List';
import SchedulePickup from 'components/pages/SchedulePickup';
import SchedulePickupIcon from '@material-ui/icons/LocalShipping';
import Warehouse from 'components/pages/Warehouse';
//import Refund from 'components/pages/Refund'; // Pendiente de hablar con el cliente
import IMWarehouse from 'components/pages/IMWarehouse';
import IMCategories from 'components/pages/IMCategories';
import IMCategoriesPromotion from 'components/pages/IMCategoriesPromotion';
import IMProviders from 'components/pages/IMProviders';
import IMProducts from 'components/pages/IMProducts';
import IMAdjustment from 'components/pages/IMAdjustment';
import IMInventoryEntry from 'components/pages/IMInventoryEntry';
import DispatchesReports from 'components/pages/DispatchesReports';
import Packages from 'components/pages/Packages';
import { ROLE_COMPRAS, ROLE_DROPSHIPPER, ROLE_ADMINISTRATOR } from 'constants/roleType';
import IMInventoryOutput from 'components/pages/IMInventoryOutput';
import CrossingInvoices from 'components/pages/CrossingInvoices';

import {
  Assessment as AssessmentIcon,
  AttachMoneyOutlined as AttachMoneyOutlinedIcon,
  Build as BuildIcon,
  Category as CategoryIcon,
  Dashboard as PackagesIcon,
  FindInPage as FindInPageIcon,
  LocalAtm as LocalAtmIcon,
  MoveToInbox as MoveToInboxIcon,
  OpenInBrowser as OpenInBrowserIcon,
  PeopleAlt as PeopleAltIcon,
  StoreMallDirectory as WarehouseIcon,
  ViewList as ViewListIcon,
  Receipt as ReceiptIcon
} from '@material-ui/icons';
const routes = [
  {
    path: '/admin/orders',
    name: 'Pedidos',
    icon: OrderIcon,
    permission: [ROLE_DROPSHIPPER, ROLE_COMPRAS],
    component: Orders
  },
  {
    path: '/admin/purchaseOrders',
    name: 'Ordenes de compra',
    permission: [ROLE_COMPRAS, ROLE_ADMINISTRATOR, ROLE_DROPSHIPPER, ROLE_COMPRAS],
    icon: LocalAtmIcon,
    component: PurchaseOrders
  },
  {
    path: '/admin/crossingInvoices',
    name: 'Cruce de Facturas',
    permission: [ROLE_ADMINISTRATOR],
    icon: ReceiptIcon,
    component: CrossingInvoices
  },
  {
    path: '/admin/dispatchesReports',
    name: 'Reporte de despachos',
    permission: [ROLE_ADMINISTRATOR, ROLE_DROPSHIPPER],
    icon: AssessmentIcon,
    component: DispatchesReports
  },
  {
    path: '/admin/orderTracking',
    name: 'Rastreo de pedidos',
    permission: [ROLE_COMPRAS, ROLE_ADMINISTRATOR],
    icon: FindInPageIcon,
    component: OrderTracking
  },
  // {
  //   path: '/admin/refund',
  //   name: 'Reembolso',
  //   permission: [ROLE_COMPRAS, ROLE_ADMINISTRATOR],
  //   icon: RestoreIcon,
  //   component: Refund
  // },
  {
    path: '/admin/schedule',
    name: 'Programar recogida',
    icon: SchedulePickupIcon,
    permission: [ROLE_DROPSHIPPER, ROLE_COMPRAS],
    component: SchedulePickup
  },
  {
    path: '/admin/warehouse',
    name: 'Bodegas',
    permission: [ROLE_DROPSHIPPER, ROLE_COMPRAS],
    icon: WarehouseIcon,
    component: Warehouse
  },
  {
    path: '/admin/packages',
    name: 'Paquetes',
    permission: [ROLE_DROPSHIPPER, ROLE_COMPRAS],
    icon: PackagesIcon,
    component: Packages
  },
  {
    path: '/admin/inventoryManagement/IMWarehouse',
    name: 'Maestro Bodegas',
    permission: [ROLE_ADMINISTRATOR],
    icon: WarehouseIcon,
    component: IMWarehouse
  },
  {
    path: '/admin/inventoryManagement/IMInventoryEntry',
    name: 'Entradas',
    icon: MoveToInboxIcon,
    permission: [ROLE_ADMINISTRATOR, ROLE_COMPRAS],
    component: IMInventoryEntry
  },
  {
    path: '/admin/inventoryManagement/IMInventoryOutput',
    name: 'Salidas',
    icon: OpenInBrowserIcon,
    permission: [ROLE_ADMINISTRATOR, ROLE_COMPRAS],
    component: IMInventoryOutput
  },
  {
    path: '/admin/inventoryManagement/IMCategories',
    name: 'Categorías',
    permission: [ROLE_ADMINISTRATOR],
    icon: CategoryIcon,
    component: IMCategories
  },
  {
    path: '/admin/inventoryManagement/IMCAPromotion',
    name: 'Categorías Promoción',
    icon: AttachMoneyOutlinedIcon,
    permission: [ROLE_ADMINISTRATOR],
    component: IMCategoriesPromotion
  },
  {
    path: '/admin/inventoryManagement/IMProviders',
    name: 'Maestro Proveedores',
    permission: [ROLE_ADMINISTRATOR, ROLE_COMPRAS],
    icon: PeopleAltIcon,
    component: IMProviders
  },
  {
    path: '/admin/inventoryManagement/IMProducts',
    name: 'Maestro Productos',
    icon: ViewListIcon,
    permission: [ROLE_ADMINISTRATOR],
    component: IMProducts
  },
  {
    path: '/admin/inventoryManagement/IMAdjustment',
    name: 'Ajustes',
    icon: BuildIcon,
    permission: [ROLE_ADMINISTRATOR],
    component: IMAdjustment
  }
];

export default routes;
